import axios from "axios";

export default axios.create({
  baseURL: "https://db.irli.org:8080/api",
  headers: {
    "Content-type": "application/json"
  }
});